import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';

const productsCompareRootSelector = createFeatureSelector('productsCompare');

export const getValidationError = createSelector(
  productsCompareRootSelector,
  (state) => state.validationError,
);
